import "./base.css";
import "./app.css";

import Auth from "#root/components/auth";
import Routes from "#root/pages/routes";
import type { ReactNode } from "react";
import { useEffect } from "react";

import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";

declare global {
  interface Window {
    //TODO: This exists so that the static page generator can navigate. There must be a better way
    navigate: ReturnType<typeof useNavigate>;
  }
}
declare const ga: (command: string, ...args: any[]) => void;

export default function (): ReactNode {
  return (
    <BrowserRouter>
      <Auth>
        <Routes/>
        <LocationMinder/>
      </Auth>
    </BrowserRouter>
  );
}

function LocationMinder() {
  //TODO: This exists so that the static page generator can navigate. There must be a better way
  window.navigate = useNavigate();
  const location = useLocation();

  useEffect(() => ga("create", "UA-85309102-1", "auto"), []);

  useEffect(() => {
    window.scrollTo(0, 0);
    ga("set", "location", `${window.location.origin}${location.pathname}${location.search}${location.hash}`);
    ga("set", "page", location.pathname);
    ga("set", "title", document.title);
    ga("send", "pageview");
  }, [location]);

  return null;
}
